import { format, isValid } from 'date-fns';

export const get12HourTime = (time: string) => {
	// Validate input format
	if (!time || typeof time !== 'string') {
		return time || '';
	}

	const parts = time.split(':');
	if (parts.length !== 2) {
		return time; // Return original if not in HH:MM format
	}

	const hours = Number(parts[0]);
	const minutes = Number(parts[1]);

	// Validate hours and minutes are numbers and in valid range
	if (Number.isNaN(hours) || Number.isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
		return time; // Return original if invalid values
	}

	const date = new Date(2023, 1, 1, hours, minutes);

	// Verify date is valid before formatting
	if (!isValid(date)) {
		return time; // Return original if date is invalid
	}

	return format(date, 'h:mm a').replace(' ', '').toLowerCase();
};
